import { useToday } from '../../hooks/today';

import { Greeting } from '../greeting';
import { InvitationCard } from '../invitation-card';
import { LoadFailed } from '../load-failed';
import { NewNote } from '../new-note';
import { NextAppointment } from '../next-appointment';
import { OpenQuestionnaires } from '../open-questionnaires';
import { TodayRecord } from '../today-record';
import { WeekRecords } from '../week-records';

import styles from './style.module.css';

// The home page (C28), as drawn in the blueprint: a greeting with the date;
// one card holding this week's records and the next appointment; the note for
// the patient they have not opened yet and any clinician's invitation waiting
// for an answer (C22); then today's record and the open questionnaires, side
// by side on a desktop.
//
// The appointment half, the note card and the invitation cards are there
// only when there is something to show.
export function Today() {
  const { data, error, retry, markNoteSeen } = useToday();

  if (error != null) {
    return <LoadFailed onRetry={ retry }/>;
  }

  if (data === undefined) {
    return null;
  }

  const { dailyRecords, nextAppointment, unseenNote, assignments, invitations } = data;

  const day = dailyRecords.find(function({ date: recorded }) {
    return recorded === data.today;
  });

  let appointment = null;

  if (nextAppointment !== null) {
    appointment = (
      <>
        <div className={ styles.rule } aria-hidden='true'></div>

        <NextAppointment appointment={ nextAppointment }/>
      </>
    );
  }

  let note = null;

  if (unseenNote !== null) {
    note = <NewNote note={ unseenNote } onOpen={ markNoteSeen }/>;
  }

  const waiting = invitations.map(function(invitation) {
    return <InvitationCard key={ invitation.id } invitation={ invitation }/>;
  });

  return (
    <section className={ styles.today }>
      <Greeting day={ data.today }/>

      <section className={ styles.summary }>
        <WeekRecords days={ dailyRecords } today={ data.today }/>

        { appointment }
      </section>

      { note }

      { waiting }

      <div className={ styles.columns }>
        <TodayRecord day={ day }/>

        <OpenQuestionnaires assignments={ assignments }/>
      </div>
    </section>
  );
}
